import sortBy from 'lodash/sortBy';

export const copyTextToClipboard = (text: string) =>
  navigator.clipboard.writeText(text);

export const prioritizeElement = (
  arr: string[],
  target: number | undefined,
) => {
  if (!target || !arr?.length) return [];
  return sortBy(arr, (el) => (Number(el) === target ? 0 : 1));
};

export const removeUndefinedValues = <T extends Record<string, any>>(
  obj: T,
): T =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key as keyof T] = value;
    }
    return acc;
  }, {} as T);
